import { firebase } from 'src/db/db';
const storageRef = firebase.storage().ref();

/**
 * getMusic - Return array of all songs for given musician.
 * 
 * @param {*} musician - musician to get music for.
 */
const getMusic = async (musician) => {
    const audioArray = [];
    const path = "musicians/" + musician + "/audio/";
    const listRef = storageRef.child(path);
    // Find all the audio tracks.
    const res = await listRef.listAll()
    for (let i = 0; i < res.items.length; i++) {
        const url = await res.items[i].getDownloadURL()
        audioArray.push({
            url: url,
            name: res.items[i].name
        });
    }
    return audioArray;
};

/**
 * deleteSong - Delete song from Storage & Firebase.
 * @param {*} musician 
 * @param {*} songName 
 */
const deleteSong = async (musician, songName) => {

    // 1. Delete Song from Firebase Storage.
    const songRef = storageRef.child("musicians/" + musician + "/audio/" + songName)
    const result = await songRef.delete();
    
    // 2. Return result.
    return result;
};

export {
    deleteSong,
    getMusic
}